var panasonic_N2QADC000006 = {
    name: "N2QADC000006",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,106,187,106,162],
        },
        {
            // function: "input",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,107,91,118,136],
        },
        {
            function: "aspect",
            name: "aspect",
            icon: "aspect",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,170,214,183,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,117,91,214,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,125,221,170,32],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,251,246,168,128],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,181,93,214,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,181,187,186,32],
        },
        {
            function: "KEY_F",
            name: "KEY_F",
            icon: "KEY_F",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,119,223,168,128],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,213,189,186,32],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,186,187,86,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,106,219,110,136],
        },
        {
            function: "norm",
            name: "norm",
            icon: "norm",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,125,110,218,32],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,90,218,238,136],
        },
        {
            function: "digitalzoom-",
            name: "digitalzoom-",
            icon: "digitalzoom-",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,111,218,234,32],
        },
        {
            function: "digitalzoom+",
            name: "digitalzoom+",
            icon: "digitalzoom+",
            command: [116,0,4,209,1,128,1,209,1,228,4,244,13,152,6,209,1,82,33,55,255,191,247,187,255,223,235,168,128],
        },
    ]
}
export default panasonic_N2QADC000006